import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { ApprovalAttendanceResponse } from "@/models/approval/ApprovalResponse";
import ApprovalTableBase, { HeaderType } from "./ApprovalTableBase.vue";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { $alert } from "@/plugins/alert/alert";
import { $confirm } from "@/plugins/confirm/confirm";
import { useApproval } from "@/composable/Approval";
import AttendanceDialog from "../form/AttendanceDialog.vue";
import AttendanceExpandItem from "../expand/AttendanceExpandItem.vue";
import Vuex from "@/store/index";
import { Authority } from "@/models/enum/Enum";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeAttendanceTable',
  setup(__props) {

const approval = useApproval();

const header: HeaderType = {
  key: "recordId",
  date: "attendanceDate",
  user: "employeeName",
  affiliation: "affiliationName",
  approval: "approvalState"
};

const title = "勤務時間変更申請承認";

const selected = ref<ApprovalAttendanceResponse[]>([]);
const items = ref<ApprovalAttendanceResponse[]>([]);
const form = ref<ApprovalSearchRequest>(approval.getForm());

const isDisabled = computed(() => {
  const authority = Vuex.state.authority;
  return authority < Authority.Manager;
});

const getItems = async (request: ApprovalSearchRequest) => {
  const response = await $post<ApprovalAttendanceResponse[]>(
    Paths.approval.attendance.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onResolve = async (
  items: ApprovalAttendanceResponse[],
  selected: ApprovalAttendanceResponse[]
) => {
  const message = `${items.length}件承認します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.attendance.resolve, items);
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();
  console.log("selected", selected);
  selected = [];
};

const onReject = async (
  items: ApprovalAttendanceResponse[],
  selected: ApprovalAttendanceResponse[]
) => {
  const message = `${items.length}件却下します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.attendance.reject, items);
  if (result) $alert("success", `${result}件却下しました。`);
  await onSearch();
  console.log("selected", selected);
  selected = [];
};

const onCancel = async (
  item: ApprovalAttendanceResponse,
  selected: ApprovalAttendanceResponse[]
) => {
  const message = "承認を取り消します。\nよろしいですか？";
  if (!(await $confirm(message))) return;

  const result = await $post(
    `${Paths.approval.attendance.cancel}/${item.recordId}`
  );
  if (result) {
    $alert("success", "取消に成功しました。");
    await onSearch();
    console.log("selected", selected);
    selected = [];
  }
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,approval, header, title, selected, items, form, isDisabled, getItems, onSearch, onResolve, onReject, onCancel, ApprovalTableBase, AttendanceDialog, AttendanceExpandItem }
}

})